import { render, staticRenderFns } from "./LmUploadFilesBuilderUi.vue?vue&type=template&id=96af4f0c&"
import script from "./LmUploadFilesBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmUploadFilesBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports